import React, { useEffect, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useMessages } from "../../context/MessageContext";
import { jwtDecode } from "jwt-decode";
import Modal from "../../utils/modalUtils";

const Inbox = ({ userId, recipientName = "" }) => {
  const navigate = useNavigate();
  const {
    messages = [],
    privateMessages = [],
    fetchMessagesForProfile,
  } = useMessages();

  const isLoggedIn = Boolean(localStorage.getItem("accessToken"));

  // Token se userId nikaal rahe hain - useMemo se optimize kiya
  const tokenUserId = useMemo(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken?.userId || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  }, [isLoggedIn]); // jab login state change ho tabhi recalculate karo

  // Admin role check karne ke liye
  const userRole = useMemo(() => {
    const token = localStorage.getItem("accessToken");
    if (!token) return null;
    try {
      const decodedToken = jwtDecode(token);
      return decodedToken?.role || null;
    } catch (error) {
      console.error("Error decoding token for role:", error);
      return null;
    }
  }, [isLoggedIn]);

  // Check kar rahe hain ki user admin hai ya userId 1 hai ya same user hai
  const isAdmin = userRole === 1;
  const isUserId1 = userId && String(userId) === "1";
  const isSameUser =
    isLoggedIn &&
    tokenUserId &&
    userId &&
    String(tokenUserId) === String(userId);

  const canEditProfile = isLoggedIn && (isAdmin || isUserId1 || isSameUser);

  useEffect(() => {
    if (userId) {
      fetchMessagesForProfile(userId);
    } else {
      fetchMessagesForProfile();
    }
  }, [fetchMessagesForProfile, userId]);

  const handleRowClick = (msg) => {
    navigate("/carter/msgboard", { state: { message: msg } });
  };
  const handleInboxRowClick = (msg) => {
    if (!isSameUser) {
      Modal.fire({
        icon: "error",
        title: "Error",
        text: "Log in to view your messages.",
        confirmButtonText: "OK",
        confirmButtonColor: "#addd1e",
      });
      return;
    }
    navigate("/carter/inboxboard", { state: { message: msg } });
  };
  const handlePostMessageClick = (e) => {
    if (!isLoggedIn) {
      e.preventDefault();
      Modal.fire({
        icon: "error",
        title: "Error",
        text: "You must be logged in to post a message.",
        confirmButtonText: "OK",
        confirmButtonColor: "#addd1e",
      });
    } else {
      e.preventDefault();
      Modal.fire({
        icon: "error",
        title: "Error",
        text: "Public message board coming soon.",
        confirmButtonText: "OK",
        confirmButtonColor: "#addd1e",
      });
    }
  };

  return (
    <div className="col-sm-12 col-lg-4">
      <div className="inbox-head">
        <div className="profile-caption heading-golfer largeYHeightHeader">
          <h4>{isSameUser ? "Your Inbox" : "Inbox"}</h4>
          <img src="/images/inbox.png" alt="msg" />
        </div>
        <div className="clear">&nbsp;</div>
        <div className="shadow">
          <div className="tbl-msg-div">
            <table className="messages" id="private-message" style={{ width: "100%", tableLayout: "fixed" }}>
              <thead>
                <tr>
                  <th>From</th>
                  <th>Subject</th>
                </tr>
              </thead>
              <tbody>
                {privateMessages.length > 0 ? (
                  privateMessages.map((msg, index) => (
                    <tr
                      key={msg.id || index}
                      className={index % 2 === 0 ? "even" : "odd"}
                    >
                      <td>{msg.poster || msg.sender || "Unknown"}</td>
                      <td
                        title={msg.subject || "No Subject"}
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          cursor: "pointer",
                          color: "#7a9234",
                          textDecoration: "underline",
                          fontWeight: 500,
                        }}
                        onClick={() => handleInboxRowClick(msg)}
                      >
                        <span>{msg.subject || "No Subject"}</span>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="odd">
                    <td>No private messages</td>
                    <td></td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <div className="public-post green-post-link">
            <Link
              to={`/carter/sendMessage?userId=${userId || ""}`}
              state={{ recipientName }}
              className="green ie-post-link"
            >
              Leave a Message
            </Link>
          </div>
        </div>
        <div className="clear">&nbsp;</div>
      </div>

      {/* PUBLIC MESSAGE BOARD - PUBLIC MESSAGES */}
      <div className="profile-caption heading-golfer largeYHeightHeader">
          <h4>Public Message Board</h4>

        <img src="/images/public-bd-icon.png" alt="msg" />
      </div>
      <div className="clear">&nbsp;</div>
      <div className="shadow">
        <div className="tbl-msg-div">
          <table className="messages" id="public-message" style={{ width: "100%", tableLayout: "fixed" }}>
            <thead>
              <tr>
                <th>From</th>
                <th>Subject</th>
              </tr>
            </thead>
            <tbody>
              {messages.length > 0 ? (
                messages.map((msg, index) => (
                  <tr
                    key={index}
                    className={index % 2 === 0 ? "even" : "odd"}
                  >
                    <td>{msg.poster || msg.sender || "Unknown"}</td>
                    <td
                      title={msg.subject || "No Subject"}
                      style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        cursor: "pointer",
                        color: "#333",
                        textDecoration: "none",
                        fontWeight: 500,
                      }}
                      onClick={() => handleRowClick(msg)}
                    >
                      {msg.subject || "No Subject"}
                    </td>
                  </tr>
                ))
              ) : (
                  <tr className="odd">
                    <td>No public messages</td>
                    <td></td>
                  </tr>
              )}
            </tbody>
          </table>
        </div>
        <div className="public-post green-post-link">
          <Link
            to="/carter/msgboard"
            className="green ie-post-link"
            onClick={handlePostMessageClick}
          >
            Post a Message
          </Link>
        </div>
      </div>

      {canEditProfile && (
        <div className="public-post green-post-link text-right">
          <Link
            to={`/carter/editprofile?userId=${userId}`}
            className="green ie-post-link"
          >
            EDIT PROFILE
          </Link>
        </div>
      )}
    </div>
  );
};

export default Inbox;
